export default __webpack_public_path__ + "static/recent-postcard-2-3a40676967249f1825b1bfb77ce77628.jpeg";